import { createContext, useContext } from 'react'

/**
 * Lets a page rendered inside ChromelessLayout hide that layout's "Powered by" footer
 * (e.g. the stream-unavailable 404 must show no footer). The default is a no-op so
 * components also work outside ChromelessLayout.
 */
export const FooterVisibilityContext = createContext<(hidden: boolean) => void>(() => {})

export function useSetChromelessFooterHidden(): (hidden: boolean) => void {
  return useContext(FooterVisibilityContext)
}
